import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
const useDeleteItem = (axiosPrivate, deleteEndpoint, deleteAction) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const deleteItem = async (id) => {
    try {
      await axiosPrivate.delete(`${deleteEndpoint}/${id}`);
      deleteAction(id);
      enqueueSnackbar(t("deleteMessageSuccess"), { variant: "success" });
      //enqueueSnackbar( t("deleteMessageSuccess"), { variant: "success" });
    } catch (err) {
      if (err?.response?.data === "Deletion of this role is not allowed.") {
        enqueueSnackbar(err?.response?.data, { variant: "error" });
      } else if (err?.response?.data?.message == "Cannot delete this entity as it is currently in use.") {
        enqueueSnackbar(t("deleteCannotDeleteIsUsed"), { variant: "warning" });
      } else {
        console.error(err);
        enqueueSnackbar(t("deleteMessageError"), { variant: "error" });

      }
    }
  };

  return deleteItem;
};

export default useDeleteItem;
